import React from "react";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import DraftsTwoToneIcon from "@mui/icons-material/DraftsTwoTone";
import FaceTwoToneIcon from "@mui/icons-material/FaceTwoTone";
import GroupsTwoToneIcon from "@mui/icons-material/GroupsTwoTone";
import PersonAddTwoToneIcon from "@mui/icons-material/PersonAddTwoTone";
import SensorsTwoToneIcon from "@mui/icons-material/SensorsTwoTone";
import Typography from "@mui/material/Typography";
import clsx from "clsx";

export const REFERENTE_MENU_ITEMS = [
	{
		id: "Dati referente",
		label: "Dati referente",
		description: "Anagrafica e recapiti",
		icon: FaceTwoToneIcon,
		color: "#2f63ff",
		color2: "#12cbd4",
	},
	{
		id: "Dati azienda",
		label: "Dati azienda",
		description: "Contatti e sede",
		icon: AssignmentTwoToneIcon,
		color: "#00a6a6",
		color2: "#60d394",
	},
	{
		id: "Utenti azienda",
		label: "Utenti azienda",
		description: "Ruoli e accessi",
		icon: GroupsTwoToneIcon,
		color: "#ff9f1c",
		color2: "#ffbf69",
	},
	{
		id: "Crea utente",
		label: "Crea utente",
		description: "Nuova utenza",
		icon: PersonAddTwoToneIcon,
		color: "#7c4dff",
		color2: "#23c9ff",
	},
	{
		id: "Mail inviate",
		label: "Mail inviate",
		description: "No-reply e invii",
		icon: DraftsTwoToneIcon,
		color: "#ef476f",
		color2: "#ff9a8b",
	},
	{
		id: "Utenti online",
		label: "Utenti online",
		description: "Sessioni attive",
		icon: SensorsTwoToneIcon,
		color: "#2fb344",
		color2: "#22d3ee",
	},
];

const ReferenteDrawer = ({classes, selectMenuItem, stato}) => (
	<aside className={classes.drawer}>
		<header className={classes.drawerHeader}>
			<Typography className={classes.drawerTitle}>Area azienda</Typography>
			<Typography className={classes.drawerSubtitle}>
				Scegli la sezione da aggiornare.
			</Typography>
		</header>
		<nav className={classes.drawerList} aria-label="Sezioni referente azienda">
			{REFERENTE_MENU_ITEMS.map((item) => {
				const Icon = item.icon;
				const selected = stato === item.id;

				return (
					<button
						key={item.id}
						className={clsx(classes.drawerItem, selected && classes.drawerItemSelected)}
						onClick={() => selectMenuItem(item.id)}
						style={{
							"--company-color": item.color,
							"--company-color-2": item.color2,
						}}
						type="button"
					>
						<span className={classes.drawerIcon}>
							<Icon fontSize="small"/>
						</span>
						<span>
							<Typography className={classes.drawerItemTitle}>{item.label}</Typography>
							<Typography className={classes.drawerItemMeta}>{item.description}</Typography>
						</span>
					</button>
				);
			})}
		</nav>
	</aside>
);

export default React.memo(ReferenteDrawer);
